import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { RoundTo3 } from "./RoundTo3";
import { XML_Param4 } from "./XML_Param4";

export function XML_DrawLinePPT(x1, y1, x2, y2, lineColor, thickness, dashed, drawElement, layer) {
  //NOTE: we just added this shifting code chunk
  x1 = XML_ScaleAndShiftX(x1, drawElement, layer);
  x2 = XML_ScaleAndShiftX(x2, drawElement, layer);
  y1 = XML_ScaleAndShiftY(y1, drawElement, layer);
  y2 = XML_ScaleAndShiftY(y2, drawElement, layer);

  y1 = drawElement.ConvertY(y1);
  y2 = drawElement.ConvertY(y2);

  XML_Param4("ln", RoundTo3(x1), RoundTo3(y1), RoundTo3(x2), RoundTo3(y2), drawElement);
  if (dashed) dashed = 1;
  else dashed = 0;
  XML_Param4("p", lineColor, lineColor, thickness, dashed, drawElement);
}
